import { useMutation } from "@tanstack/react-query";

import { useAuthStore } from "../../auth/store";
import {
  loginUser,
  type AuthCredentialsRequest,
  type AuthTokenResponse,
} from "./api";

// Хук формы логина: оборачивает mutation вокруг loginUser и при
// успехе пишет identity-флаг в auth-store. Сам JWT в JS не хранится
// (#916) — backend поставил его в HttpOnly cookie. Компонент только
// показывает форму и читает `.isError` / `.error` для UI-feedback.
export function useLogin(): ReturnType<
  typeof useMutation<AuthTokenResponse, Error, AuthCredentialsRequest>
> {
  return useMutation<AuthTokenResponse, Error, AuthCredentialsRequest>({
    mutationFn: (creds) => loginUser(creds),
    onSuccess: (data) => {
      // `getState()` вместо подписки на selector — selector создаёт
      // новый snapshot после `set` и провоцирует ре-рендер; нам
      // тут нужно только разово дёрнуть action, без подписки.
      //
      // Сессия входа org-less по ADR-0038 (§2): `data.org_id` —
      // хинт, не грант, и намеренно не используется. Активную
      // организацию ставит только `switchOrganization` (см.
      // `useSwitchOrganization`) или сверка с `GET /me` в
      // `RequireActiveOrg`.
      useAuthStore.getState().login({ userId: data.user_id, orgId: null });
    },
  });
}
